import { simpleFetch } from "./acCommon"

export const FORGOTPASSWORD_DATACHANGE = 'FORGOTPASSWORD_DATACHANGE'
export const forgotPasswordDataChange = changes => ({type: FORGOTPASSWORD_DATACHANGE, changes})

export const FORGOTPASSWORD_METACHANGE = 'FORGOTPASSWORD_METACHANGE'
export const forgotPasswordMetaChange = changes => ({type: FORGOTPASSWORD_METACHANGE, changes})

export const processDataChange = changes => (dispatch, getState) => {

    dispatch(forgotPasswordDataChange(changes))

    let { email } = getState().dataReducer.forgotPassword

    if (email !== '' && email !== ' ') {
        dispatch(forgotPasswordMetaChange({ canSubmit: true }))
    }
    else {
        dispatch(forgotPasswordMetaChange({ canSubmit: false }))
    }

}

export const FORGOTPASSWORD = 'FORGOTPASSWORD'
export const FORGOTPASSWORD_REQUEST = 'FORGOTPASSWORD_REQUEST'
export const FORGOTPASSWORD_SUCCESS = 'FORGOTPASSWORD_SUCCESS'
export const FORGOTPASSWORD_FAILURE = 'FORGOTPASSWORD_FAILURE'

export const forgotPassword = () => (dispatch, getState) => {

    let { email  } = getState().dataReducer.forgotPassword
    let body = JSON.stringify({
        email: email,
    })

    let requestMeta = {
        spinnerMessageKey: 'spinner_message_forgot_password',
    }

    dispatch(simpleFetch('/accounts/password', {
        method: 'POST',
        body: body
    }, FORGOTPASSWORD, requestMeta, ''))
}


// WEBPACK FOOTER //
// ./src/actions/acAuth.js